import { post} from '@/util/utils';
import axios from 'axios';
var appKey= "060e684879a0fea6"
var sign="MTJmMTZjMmI5MTg1YmNkNWNkY2Y2MzQ0NmNiNTgxNzRiNjA3NzMwOWE0YTI1Zjk0Nzc1YWNhZWZmNDk0ODM4YQ=="

function queryMachineWorkDetail(machineNumber) {
	return post('dashboard/queryMachineWorkDetail', {
		machineNumber: machineNumber
	});
}

function getEuipment(){
    const payload = {
        "appKey": appKey,
        "sign": sign,
        "worksheetId": 'equ_list',
        "viewId": "",
        "pageSize": 1000,
        "pageIndex": 1,
      };
    const headers = {
        'Content-Type': 'application/json'
    }
    var response_data=axios.post('/api/v2/open/worksheet/getFilterRows', payload,{headers})
    return response_data;
}

export {getEuipment, queryMachineWorkDetail};
